import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const toggleFAQ = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  const faqs: FAQItem[] = [{
    question: 'No tengo tiempo ni me gusta cocinar, ¿me va a servir?',
    answer: 'Sí. Todo está pensado para 10–15 min reales y 4–5 pasos. Si podés armar un tostado, podés hacer estas recetas.'
  }, {
    question: 'Mi airfryer es chica/antigua, ¿funciona igual?',
    answer: 'Funciona. Indicamos cantidades por ración y cómo ajustar tiempos/temperatura. También sugerimos "cocción, en tandas", sin perder crocancia.'
  }, {
    question: '¿Necesito balanza o ingredientes raros?',
    answer: 'No. Usamos tazas/cucharas y cosas que conseguís en súper chino/barrio. Hay equivalencias simples y swaps por si te falta algo.'
  }, {
    question: 'Estoy cuidando macros/definición, ¿cómo sé qué comer?',
    answer: 'Cada receta trae macros orientativas y opciones para subir proteína o bajar carbo/grasas sin perder sabor.'
  }, {
    question: '¿Y si soy veggie o tengo que evitar gluten?',
    answer: 'Muchas recetas tienen alternativa veggie y marcamos sin TACC cuando aplica. Igual, revisá etiquetas de cada insumo.'
  }, {
    question: '¿Me voy a quedar con hambre?',
    answer: 'No. Hay guías de porción y combos (plato + guarnición) para saciedad. Además, snacks altos en proteína que salvan.'
  }, {
    question: '¿Qué pasa si no me convence?',
    answer: 'Tenés 7 días de garantía. Si no te sirve, te devolvemos la plata sin vueltas.'
  }, {
    question: '¿Cómo pago? ¿Hay cuotas?',
    answer: 'Aceptamos tarjetas, débito y Mercado Pago. Habilitamos cuotas cuando la plataforma lo permite. Factura en AR.'
  }];
  // Only show first 3 FAQs initially
  const visibleFaqs = showAllFaqs ? faqs : faqs.slice(0, 3);
  return <section className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <div className="text-center mb-10" data-id="element-143">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-144">
            Preguntas frecuentes
          </h2>
          <p className="text-gray-700" data-id="element-145">
            Todo lo que necesitás saber antes de comprar
          </p>
        </div>
        <div className="space-y-4" data-id="element-146">
          {visibleFaqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-147">
              <button className="flex justify-between items-center w-full px-6 py-4 text-left" onClick={() => toggleFAQ(index)} data-id="element-148">
                <span className="font-medium text-gray-900" data-id="element-149">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-teal-600 flex-shrink-0" data-id="element-150" /> : <ChevronDownIcon className="h-5 w-5 text-teal-600 flex-shrink-0" data-id="element-151" />}
              </button>
              {openIndex === index && <div className="px-6 pb-4 text-gray-700" data-id="element-152">{faq.answer}</div>}
            </div>)}
        </div>
        {!showAllFaqs && <div className="mt-6 text-center" data-id="element-153">
            <button onClick={() => setShowAllFaqs(true)} className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-6 rounded-lg transition duration-300" data-id="element-154">
              Ver más preguntas
            </button>
          </div>}
        <div className="mt-10 text-center" data-id="element-155">
          <p className="text-gray-700 mb-4" data-id="element-156">
            Comprás una vez, recibís actualizaciones gratis para siempre.
          </p>
          <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300" data-id="element-157">
            Quiero todo hoy solo por $19.990
          </a>
        </div>
      </div>
    </section>;
};